import { GridCellEditCommitParams } from '@/global/components/DataGrid/utils/types'
import { Rubrica, rubrica } from 'service/api'
import { toast } from 'sonner'

function parse({ id, clienteId, codigo, referencia }: Partial<Rubrica>) {
    return {
        id: id ? Number(id) : undefined,
        clienteId: clienteId ? Number(clienteId) : undefined,
        codigo: codigo ? Number(codigo) : undefined,
        referencia: referencia ? String(referencia) : undefined,
    }
}

export function CommitService() {
    const { mutate } = rubrica.mutations.useUpdate({
        invalidateQuery: true,
    })

    const handleSubmit = (model: GridCellEditCommitParams) => {
        const { field, value, id } = model

        const payload = parse({ [field]: value })

        return mutate(
            { ...payload, id: Number(id.toString()) },
            {
                onError: err => {
                    toast.error('Alterações não foram salvas. ' + err.message)
                },
                onSuccess: () => {
                    toast.success('Alterações foram salvas')
                },
            },
        )
    }

    return { handleSubmit }
}
